import {
    PRACTITIONER_LIST_REQUEST, PRACTITIONER_LIST_SUCCESS, PRACTITIONER_LIST_FAIL,
    PRACTITIONER_LIST_BY_IDS_REQUEST, PRACTITIONER_LIST_BY_IDS_SUCCESS, PRACTITIONER_LIST_BY_IDS_FAIL,
    PRACTITIONER_DETAILS_REQUEST, PRACTITIONER_DETAILS_SUCCESS, PRACTITIONER_DETAILS_FAIL, PRACTITIONER_DETAILS_RESET,
    PRACTITIONER_CREATE_REQUEST, PRACTITIONER_CREATE_SUCCESS, PRACTITIONER_CREATE_FAIL, PRACTITIONER_CREATE_RESET,
    PRACTITIONER_UPDATE_REQUEST, PRACTITIONER_UPDATE_SUCCESS, PRACTITIONER_UPDATE_FAIL, PRACTITIONER_UPDATE_RESET,
    PRACTITIONER_DELETE_REQUEST, PRACTITIONER_DELETE_SUCCESS, PRACTITIONER_DELETE_FAIL,
    PRACTITIONER_DTO_REQUEST, PRACTITIONER_DTO_SUCCESS, PRACTITIONER_DTO_FAIL, PRACTITIONER_DTO_RESET,
    SET_CURRENT_PAGE,
} from '../constants/applicationUserConstants';

export const applicationUserListReducer = (state = { applicationUsers: [] }, action) => {
    switch (action.type) {
        case PRACTITIONER_LIST_REQUEST:
            return { loading: true, applicationUsers: [] };
        case PRACTITIONER_LIST_SUCCESS:
            return {
                loading: false,
                applicationUsers: action.payload.items,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                totalCount: action.payload.totalCount,
            };
        case SET_CURRENT_PAGE:
            return {
                ...state,
                currentPage: action.payload
            };
        case PRACTITIONER_LIST_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const applicationUserListByIdsReducer = (state = { applicationUsers: [] }, action) => {
    switch (action.type) {
        case PRACTITIONER_LIST_BY_IDS_REQUEST:
            return { loading: true, applicationUsers: [] };
        case PRACTITIONER_LIST_BY_IDS_SUCCESS:
            return { loading: false, applicationUsers: action.payload,
            };
        case PRACTITIONER_LIST_BY_IDS_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const applicationUserDetailsReducer = (state = { applicationUser: {} }, action) => {
    switch (action.type) {
        case PRACTITIONER_DETAILS_REQUEST:
            return { loading: true, ...state };
        case PRACTITIONER_DETAILS_SUCCESS:
            return { loading: false, applicationUser: action.payload };
        case PRACTITIONER_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        case PRACTITIONER_DETAILS_RESET:
            return { applicationUser: {} };
        default:
            return state;
    }
};

export const applicationUserDtoReducer = (state = { applicationUserDto: {} }, action) => {
    switch (action.type) {
        case PRACTITIONER_DTO_REQUEST:
            return { loading: true, applicationUserDto: {} };
        case PRACTITIONER_DTO_SUCCESS:
            return { loading: false, applicationUserDto: action.payload };
        case PRACTITIONER_DTO_FAIL:
            return { loading: false, error: action.payload };
        case PRACTITIONER_DTO_RESET:
            return { applicationUserDto: {} };
        default:
            return state;
    }
};

export const applicationUserDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case PRACTITIONER_DELETE_REQUEST:
            return { loading: true };
        case PRACTITIONER_DELETE_SUCCESS:
            return { loading: false, success: true };
        case PRACTITIONER_DELETE_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const applicationUserCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case PRACTITIONER_CREATE_REQUEST:
            return { loading: true };
        case PRACTITIONER_CREATE_SUCCESS:
            return { loading: false, success: true, applicationUser: action.payload };
        case PRACTITIONER_CREATE_FAIL:
            return { loading: false, error: action.payload };
        case PRACTITIONER_CREATE_RESET:
            return {};
        default:
            return state;
    }
};

export const applicationUserUpdateReducer = (state = { applicationUser: {} }, action) => {
    switch (action.type) {
        case PRACTITIONER_UPDATE_REQUEST:
            return { loading: true };
        case PRACTITIONER_UPDATE_SUCCESS:
            return { loading: false, success: true, applicationUser: action.payload };
        case PRACTITIONER_UPDATE_FAIL:
            return { loading: false, error: action.payload };
        case PRACTITIONER_UPDATE_RESET:
            return { applicationUser: {} };
        default:
            return state;
    }
}; 